export interface IntegratorDetail {
	code: string;
	name: string;
}

export enum IntegratorEnum {
	Other = 'O000',
	AddNewIntegrator = 'O001',
}
